import { render, staticRenderFns } from "./pacchetti.vue?vue&type=template&id=75522da0&scoped=true&"
import script from "./pacchetti.vue?vue&type=script&lang=js&"
export * from "./pacchetti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75522da0",
  null
  
)

export default component.exports